import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderDetailsForm } from '../../utils/constant';
import { Button } from './css';

const ModifyQuote = ({ orderData, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: {
      confirmationDialog,
      modifyQuote,
      continueLabel,
      modifyOrder
    },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;
  const { locale, categoryName, id, isQuoteReference } = orderData;
  const history = useHistory();

  const getLabel = () => {
    let label;
    switch (status) {
      case 'incomplete':
        label = continueLabel;
        break;
      case 'waitingOnSales':
        label = modifyOrder;
        break;
      default:
        label = modifyQuote;
    }
    return label;
  };

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=1`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{getLabel()}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to proceed with modifying the quote"
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleModifyQuote()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

ModifyQuote.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired
};

export default ModifyQuote;
